import { buildApiConfig } from '../services/api/apiClient';
import { endPointEnums } from '../services/api/endpoints';

/**
 * Parcel UI Action callbacks registry
 * Components can register callbacks instead of using window events
 */
const parcelCallbacks = {
  onParcelUpdated: [],
  onTrackingEnabled: [],
  onTrackingDisabled: [],
  onParcelArchived: [],
  onFeedbackPrompt: [],
  onParcelReturning: [],
};

/**
 * Register a callback for parcel updates
 * @param {string} eventType - Event type to listen for
 * @param {Function} callback - Callback function
 * @returns {Function} Unsubscribe function
 */
export function onParcelEvent(eventType, callback) {
  if (!parcelCallbacks[eventType]) {
    parcelCallbacks[eventType] = [];
  }
  parcelCallbacks[eventType].push(callback);
  return () => {
    parcelCallbacks[eventType] = parcelCallbacks[eventType].filter((cb) => cb !== callback);
  };
}

/**
 * Notify all registered callbacks for an event
 */
function notifyCallbacks(eventType, data) {
  if (parcelCallbacks[eventType]) {
    parcelCallbacks[eventType].forEach((cb) => {
      try {
        cb(data);
      } catch (e) {
        console.error(`[ParcelUI] Callback error for ${eventType}:`, e);
      }
    });
  }
}

/**
 * Update parcel data in UI by refetching from API
 * Notifies registered callbacks for components to react
 */
export function updateParcelUI(data, makeApiCall) {
  // Notify registered callbacks
  notifyCallbacks('onParcelUpdated', {
    parcelId: data.parcelId,
    status: data.status,
    ...data,
  });

  // Refetch parcel data from API
  if (data.parcelId && typeof makeApiCall === 'function') {
    const apiConfig = buildApiConfig(endPointEnums.GET_PARCEL_BY_ID, {
      id: data.parcelId,
    });
    makeApiCall(apiConfig, apiConfig.params);
  }
}

export function enableTrackingMap(data) {
  notifyCallbacks('onTrackingEnabled', {
    parcelId: data.parcelId,
    riderId: data.riderId,
  });
}

export function disableTrackingMap(data) {
  notifyCallbacks('onTrackingDisabled', { parcelId: data.parcelId });
}

export function archiveParcel(data) {
  notifyCallbacks('onParcelArchived', { parcelId: data.parcelId });
}

export function showFeedbackPrompt(data) {
  notifyCallbacks('onFeedbackPrompt', { parcelId: data.parcelId });
}

export function updateRouteToSender(data) {
  notifyCallbacks('onParcelReturning', { parcelId: data.parcelId });
}
